import { useState } from 'react';

const API = process.env.REACT_APP_API_URL || '';

export default function RegisterPage() {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const errs = [];
    if (!(email || '').trim()) errs.push('Sähköposti vaaditaan.');
    if (!(username || '').trim()) errs.push('Käyttäjänimi vaaditaan.');
    if (!(password || '').trim()) errs.push('Salasana vaaditaan.');
    setErrors(errs);
    if (errs.length) return;

    setSubmitting(true);
    setErrors([]);
    fetch(`${API}/api/register`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email.trim(),
        username: username.trim(),
        displayName: (displayName || username).trim(),
        password: password.trim(),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) {
          setSuccess(true);
          setEmail('');
          setUsername('');
          setDisplayName('');
          setPassword('');
        } else {
          setErrors([data.message || 'Rekisteröityminen epäonnistui.']);
        }
      })
      .catch(() => setErrors(['Yhteysvirhe. Yritä uudelleen.']))
      .finally(() => setSubmitting(false));
  };

  if (success) {
    return (
      <div className="App-block">
        <h2>Rekisteröityminen onnistui</h2>
        <p>Voit nyt kirjautua sisään käyttäjänimellä ja salasanalla.</p>
        <p>
          <a href="/">Kirjaudu sisään</a>
        </p>
      </div>
    );
  }

  return (
    <div className="App-block">
      <h2>Rekisteröidy</h2>
      <form className="Register-form" onSubmit={handleSubmit}>
        <label htmlFor="register-email">
          Sähköposti
          <input
            id="register-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="sähköposti@esimerkki.fi"
            autoComplete="email"
            disabled={submitting}
          />
        </label>
        <label htmlFor="register-username">
          Käyttäjänimi
          <input
            id="register-username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="käyttäjänimi"
            autoComplete="username"
            disabled={submitting}
          />
        </label>
        <label htmlFor="register-displayName">
          Näyttönimi (valinnainen, oletuksena käyttäjänimi)
          <input
            id="register-displayName"
            type="text"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder={username || 'näyttönimi'}
            autoComplete="name"
            disabled={submitting}
          />
        </label>
        <label htmlFor="register-password">
          Salasana
          <input
            id="register-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="salasana"
            autoComplete="new-password"
            disabled={submitting}
          />
        </label>
        {errors.length > 0 && (
          <ul className="Register-errors" role="alert">
            {errors.map((msg, i) => (
              <li key={i}>{msg}</li>
            ))}
          </ul>
        )}
        <button type="submit" className="Button" disabled={submitting}>
          {submitting ? 'Rekisteröidään…' : 'Rekisteröidy'}
        </button>
      </form>
      <p>
        <a href="/">Takaisin kirjautumiseen</a>
      </p>
    </div>
  );
}
